<div class="landing-container">
  <app-public-navigation/>


  <!-- Hero Section -->
  <section class="hero-section">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-6">
          <h1 class="hero-title">Verwalten Sie Ihre Aufgaben effizient mit TaskRadar</h1>
          <p class="hero-subtitle">Eine leistungsstarke Aufgabenverwaltungslösung, die entwickelt wurde, um die Produktivität zu steigern und Ihren Arbeitsablauf zu optimieren.</p>
          <div class="hero-buttons">
            <a class="btn btn-primary btn-lg me-3" href="mailto:kontakt@noteradar.at">Jetzt Zugang anfordern</a>
            <a class="btn btn-outline-secondary btn-lg" routerLink="/features">Mehr erfahren</a>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="hero-image">
            <img src="assets/img/taskradar.png" alt="TaskRadar Dashboard" class="img-fluid">
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Features Section -->
  <section class="features-section" id="features">
    <div class="container">
      <div class="section-header text-center">
        <h2>Leistungsstarke Funktionen</h2>
        <p>Entdecken Sie, was TaskRadar zur perfekten Lösung für Ihre Aufgabenverwaltung macht</p>
      </div>
      <div class="row">
        <div class="col-md-4">
          <div class="feature-card">
            <div class="feature-icon">
              <i class="fas fa-tasks"></i>
            </div>
            <h3>Aufgabenorganisation</h3>
            <p>Erstellen, kategorisieren und priorisieren Sie Aufgaben mit einer intuitiven Benutzeroberfläche, die alles organisiert hält.</p>
          </div>
        </div>
        <div class="col-md-4">
          <div class="feature-card">
            <div class="feature-icon">
              <i class="fas fa-calendar-alt"></i>
            </div>
            <h3>Terminverwaltung</h3>
            <p>Setzen Sie Fristen, erhalten Sie Erinnerungen und verfolgen Sie den Fortschritt, um sicherzustellen, dass alle Aufgaben pünktlich erledigt werden.</p>
          </div>
        </div>
        <div class="col-md-4">
          <div class="feature-card">
            <div class="feature-icon">
              <i class="fas fa-users"></i>
            </div>
            <h3>Teamzusammenarbeit</h3>
            <p>Teilen Sie Aufgaben, weisen Sie Verantwortlichkeiten zu und arbeiten Sie effektiv mit Ihren Teammitgliedern zusammen.</p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Benefits Section -->
  <section class="benefits-section" id="benefits">
    <div class="container">
      <div class="section-header text-center">
        <h2>Warum TaskRadar wählen?</h2>
        <p>Erleben Sie die Vorteile, die unsere Aufgabenverwaltungslösung auszeichnen</p>
      </div>
      <div class="row align-items-center">
        <div class="col-lg-6">
          <img src="assets/img/taskradar.png" alt="TaskRadar Vorteile" class="img-fluid">
        </div>
        <div class="col-lg-6">
          <div class="benefit-item">
            <h3><i class="fas fa-check-circle"></i> Gesteigerte Produktivität</h3>
            <p>Optimieren Sie Ihren Arbeitsablauf und erledigen Sie mehr in kürzerer Zeit mit unserem effizienten Aufgabenverwaltungssystem.</p>
          </div>
          <div class="benefit-item">
            <h3><i class="fas fa-check-circle"></i> Bessere Organisation</h3>
            <p>Halten Sie alle Ihre Aufgaben organisiert und zugänglich, um Verwirrung und verpasste Fristen zu vermeiden.</p>
          </div>
          <div class="benefit-item">
            <h3><i class="fas fa-check-circle"></i> Verbesserte Zusammenarbeit</h3>
            <p>Verbessern Sie die Teamkommunikation und -koordination mit gemeinsamen Aufgabenlisten und Fortschrittsverfolgung.</p>
          </div>
          <div class="benefit-item">
            <h3><i class="fas fa-check-circle"></i> Datensicherheit</h3>
            <p>Seien Sie versichert, dass Ihre Aufgabendaten mit unseren robusten Sicherheitsmaßnahmen geschützt sind.</p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Call to Action -->
  <section class="cta-section">
    <div class="container text-center">
      <h2>Bereit, Ihre Produktivität zu steigern?</h2>
      <p>Beginnen Sie noch heute mit der effizienten Verwaltung Ihrer Aufgaben mit TaskRadar.</p>
      <a class="btn btn-primary btn-lg" href="mailto:kontakt@noteradar.at">Jetzt Zugang anfordern</a>
    </div>
  </section>

  <!-- Footer -->
  <app-public-footer></app-public-footer>
</div>
